module.exports = __webpack_public_path__ + "img/Logo_taxert_sign.075a43ce.svg";